const translations = {
    unknownError: 'There was an unexpected error'
};

export default translations;
